
<div
  class="lobby-table-game-specific-wrapper lobbyTableGameSpecificWrapper--3fAEk desktop--1Txr1"
  data-role="lobby-table-game-specific-wrapper"
>
  <div
    class="lobbyTableGameSpecificData--3whkv TableHistoryStatisticTopCard--QsycZ desktop--2gB3k w-100"
  >
    <div
      v-for="(result, index) in historySlice"
      :key="index"
      class="historyItem--2gz2u isDesktop--2BuPY largeMobileIcon--3hpO8 isLobby--3wLXA"
      style="color: rgb(255, 255, 255)"
    >
      <svg width="68" height="36" viewBox="0 0 68 36">
        <g>
          <path
            fill="black"
            fill-opacity="0.4"
            d="M3.78526 0.5H52.2521C55.4556 0.5 58.4178 2.12691 60.0151 4.7727L67.0687 16.4636C67.3559 16.9398 67.5 17.4698 67.5 18C67.5 18.5302 67.3559 19.0602 67.0688 19.5363L60.0152 31.2272C58.4178 33.8731 55.4556 35.5 52.2521 35.5H3.78526C2.52401 35.5 1.4946 34.8549 0.94085 33.9432C0.659118 33.4793 0.500719 32.9471 0.500002 32.3988C0.499332 31.8861 0.637189 31.3603 0.936906 30.8637L7.45968 20.0528C7.84332 19.4166 8.03459 18.7082 8.03459 18C8.03459 17.2918 7.84332 16.5834 7.45961 15.9471L0.936865 5.13623C0.637189 4.63972 0.499332 4.11388 0.500002 3.60122C0.500719 3.05292 0.659118 2.52069 0.94085 2.05683C1.4946 1.14509 2.52401 0.5 3.78526 0.5Z"
          ></path>
          <path
            v-if="isGagnantActif(index, result)"
            :fill="getCouleur(result, index)"
            :class="getCouleur(result, index)"
            fill-opacity="0.8"
            d="M3.78526 0.5H52.2521C55.4556 0.5 58.4178 2.12691 60.0151 4.7727L67.0687 16.4636C67.3559 16.9398 67.5 17.4698 67.5 18C67.5 18.5302 67.3559 19.0602 67.0688 19.5363L60.0152 31.2272C58.4178 33.8731 55.4556 35.5 52.2521 35.5H3.78526C2.52401 35.5 1.4946 34.8549 0.94085 33.9432C0.659118 33.4793 0.500719 32.9471 0.500002 32.3988C0.499332 31.8861 0.637189 31.3603 0.936906 30.8637L7.45968 20.0528C7.84332 19.4166 8.03459 18.7082 8.03459 18C8.03459 17.2918 7.84332 16.5834 7.45961 15.9471L0.936865 5.13623C0.637189 4.63972 0.499332 4.11388 0.500002 3.60122C0.500719 3.05292 0.659118 2.52069 0.94085 2.05683C1.4946 1.14509 2.52401 0.5 3.78526 0.5Z"
          ></path>
          <text
            x="23"
            y="26"
            :fill="isGagnantActif(index, result) ? '#fff' : getCouleur(result, index)"
            font-size="23"
          >
            {{ getAffichageResultat(result) }}
          </text>
        </g>
      </svg>
    </div>
  </div>
</div>
